var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_839_4433",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_839_4433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0419 16.4582C8.2395 16.4582 6.70561 15.831 5.4402 14.5767C4.17464 13.3224 3.54186 11.7968 3.54186 9.99984V9.34921L2.0002 10.8909L1.12207 10.0128L4.16686 6.96775L7.21165 10.0128L6.33353 10.8909L4.79186 9.34921V9.99984C4.79186 11.4475 5.30145 12.6775 6.32061 13.6898C7.33992 14.7021 8.58033 15.2082 10.0419 15.2082C10.387 15.2082 10.7318 15.1705 11.0762 15.0953C11.4208 15.0198 11.7571 14.9069 12.0852 14.7563L13.0227 15.6938C12.5537 15.9459 12.0694 16.1363 11.57 16.265C11.0704 16.3938 10.561 16.4582 10.0419 16.4582ZM15.8335 13.0319L12.7887 9.98692L13.6669 9.1088L15.2085 10.6505V9.99984C15.2085 8.5522 14.6989 7.3222 13.6798 6.30984C12.6605 5.29762 11.4201 4.7915 9.95853 4.7915C9.61339 4.7915 9.2686 4.82914 8.92415 4.90442C8.57957 4.97984 8.24325 5.09282 7.9152 5.24338L6.9777 4.30588C7.44672 4.0538 7.93096 3.86338 8.4304 3.73463C8.92999 3.60588 9.43936 3.5415 9.95853 3.5415C11.7609 3.5415 13.2948 4.16866 14.5602 5.42296C15.8258 6.67727 16.4585 8.20289 16.4585 9.99984V10.6505L18.0002 9.1088L18.8783 9.98692L15.8335 13.0319Z",
    fill: "#151515"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.745c1ab3e7d89518febe283652339bce.svg";
export { ForwardRef as ReactComponent };